import Image from 'app/components/layouts/Image';
import { maxText } from 'app/utils/string';
import { Joke } from 'types/joke';
import first from 'lodash/first';
import Link from 'next/link';
import env from '.env.json';
import 'app/components/music/wrap-box.css'

const ListJokes = ({ jokes, code }) => {
  code = code == 'en' ? 'vi' : code;
  return (
    <div className="mt-2 row mx-1">
      {
        (jokes || []).map((joke: Joke) => {
          return (
            <div className='col-md-4 col-sm-6 col-xs-6 px-2 center-box' key={joke._id}>
              <div className={`mb-3 wrap-box-content wrap-box-song`}>
                <Link href={`/jokes/${joke.slug}`}>
                  <div className="m-1">
                    <div className='position-relative video-box'>
                      <Image
                        className="image-song my-auto"
                        alt={joke.title_en}
                        src={`${env.URL_API_FILE}/${joke.image_url}`}
                      />
                    </div>
                    <div className="overflow-hidden mt-1">
                      <div className="wrap-box-title text-left">
                        {joke.title_en}
                      </div>
                      <small
                        className="float-left"
                        dangerouslySetInnerHTML={{ __html: maxText(first(joke?.translates)[code], 60) }}
                      />
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ListJokes;
